"use client"
import React, { useState, useEffect } from 'react'
import './NavMenu.css'
import Link from 'next/link'
import Image from 'next/image'
import { FaAngleDown } from "react-icons/fa";
import { usePathname } from 'next/navigation';

const centerRoutes = [
  '/our-centers-of-excellence/institute-of-cardiac-sciences/interventional-cardiology',
  '/our-centers-of-excellence/institute-of-cardiac-sciences/ctvs',
  '/our-centers-of-excellence/institute-of-cardiac-sciences/heart-failure',
  '/our-centers-of-excellence/institute-of-cardiac-sciences/paediatric-cardiology',
  '/our-centers-of-excellence/institute-of-cardiac-sciences/electrophysiology-and-rfa-clinic',
  '/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/nephrology-care',
  '/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/pediatric-nephrology-care',
  '/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/renal-transplant',
  '/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/dialysis-care',
  '/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/urology-treatment',
  '/our-centers-of-excellence/department-of-neuro-science/neurology-care',
  '/our-centers-of-excellence/department-of-neuro-science/neurosurgery-department',
  '/our-centers-of-excellence/department-of-neuro-science/spine-department',
  '/our-centers-of-excellence/department-of-orthopaedics',
  '/our-centers-of-excellence/department-of-general-surgery',
  '/our-centers-of-excellence/department-of-anesthesia-and-critical-care',
  '/our-centers-of-excellence/department-of-internal-medicine',
  '/our-centers-of-excellence/department-of-pediatrics',
  '/our-centers-of-excellence/department-of-endocrinology'
];

const NavMenu = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [disableHover, setDisableHover] = useState(false);
  const pathname = usePathname();
  const isCenterActive = centerRoutes.some(route => pathname.startsWith(route));
  useEffect(() => {

    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleMenuClick = () => {
    setDisableHover(true);
    setTimeout(() => setDisableHover(false), 300);
  };
  return (
    <>
<nav className={`Css-my-sticky-navbar ${isSticky ? 'Css-sticky' : ''} ${disableHover ? 'disable-hover' : ''} Css-border-nav-header Css-background-nav-item d-none d-xl-block`}>
        <div className="container">
          <div className="row align-items-center">
            <div className='col-2 text-start'>
              <Link className="navbar-brand" href="/">
                <Image
                  src="https://cdn.dotplus.in/Cloud/Aarogyam/logo/HDNA_Aarogyam_Hospital_Logo.png"
                  alt="HDNA Aarogyam Hospital Official Logo - High Quality"
                  width={180}
                  height={51}
                  priority
                />
              </Link>
            </div>
            <div className="col-9 d-lg-flex justify-content-center">
              <div>
                <ul className="Css-nav-menu-item m-0 ps-0">
                  <li className={pathname === '/' ? 'active' : ''}>
                    <Link href="/" className='active-css'> Home</Link>
                  </li>
                  <li className={`dropdown ${disableHover ? 'disable-hover' : ''} ${pathname === '/about-us' || pathname === '/vision-and-mission' ? 'active' : ''}`}>
                    <Link href="#" className='active-css'>
                      About Us <span className="dropdown-icon"><FaAngleDown /></span>
                    </Link>
                    <ul className="dropdown-menu">
                      <li onClick={handleMenuClick}>
                        <Link href="/about-us">About</Link>
                      </li>
                      <li onClick={handleMenuClick}>
                        <Link href="/vision-and-mission">Vision and Mission</Link>
                      </li>
                    </ul>
                  </li>

                  <li className={`dropdown ${disableHover ? 'disable-hover' : ''} ${isCenterActive ? 'active' : ''}`}>
                    <Link href="#" className='active-css'>
                      Our Centers of Excellence <span className="dropdown-icon"><FaAngleDown /></span>
                    </Link>
                    <ul className="dropdown-menu">
                      <li className="dropdown">
                        <div className='Css-dropdown-icon-submenu'><Link href="#">Institute of Cardiac Sciences </Link>  <span className="dropdown-icon"><FaAngleDown /></span></div>
                        <ul className="dropdown-menu">
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/institute-of-cardiac-sciences/interventional-cardiology">Interventional Cardiology & Non Interventional Cardiology</Link>
                          </li>
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/institute-of-cardiac-sciences/ctvs">Cardiothoracic and Vascular Surgery (CTVS)</Link>
                          </li>
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/institute-of-cardiac-sciences/heart-failure">Heart Failure</Link>
                          </li>
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/institute-of-cardiac-sciences/paediatric-cardiology">Paediatric Cardiology</Link>
                          </li>
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/institute-of-cardiac-sciences/electrophysiology-and-rfa-clinic">Electrophysiology & RFA Clinic</Link>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown">
                        <div className='Css-dropdown-icon-submenu'><Link href="#">Institute of Renal Science & Renal Transplant </Link>  <span className="dropdown-icon css-margin-top-sk"><FaAngleDown /></span></div>
                        <ul className="dropdown-menu">
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/nephrology-care">Nephrology</Link>
                          </li>
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/pediatric-nephrology-care">Pediatric Nephrology</Link>
                          </li>
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/renal-transplant">Renal Transplant</Link>
                          </li>
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/dialysis-care">Dialysis</Link>
                          </li>
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/urology-treatment">Urology & Uro Surgery</Link>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown">
                        <div className='Css-dropdown-icon-submenu'><Link href="#">Department Of Neuro Science </Link>  <span className="dropdown-icon"><FaAngleDown /></span></div>
                        <ul className="dropdown-menu">
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/department-of-neuro-science/neurology-care">Neurology</Link>
                          </li>
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/department-of-neuro-science/neurosurgery-department">Neurosurgery</Link>
                          </li>
                          <li onClick={handleMenuClick}>
                            <Link href="/our-centers-of-excellence/department-of-neuro-science/spine-department">Brain & Spine Surgery</Link>
                          </li>
                        </ul>
                      </li>
                      <li onClick={handleMenuClick}>
                        <Link href="/our-centers-of-excellence/department-of-orthopaedics">Department of Orthopedics & Joint Replacement</Link>
                      </li>
                      <li onClick={handleMenuClick}>
                        <Link href="/our-centers-of-excellence/department-of-general-surgery">Department Of General Surgery </Link>
                      </li>
                      <li onClick={handleMenuClick}>
                        <Link href="/our-centers-of-excellence/department-of-anesthesia-and-critical-care">Department Of Anesthesia & Critical Care </Link>
                      </li>
                      <li onClick={handleMenuClick}>
                        <Link href="/our-centers-of-excellence/department-of-internal-medicine">Department Of Internal Medicine </Link>
                      </li>
                      <li onClick={handleMenuClick}>
                        <Link href="/our-centers-of-excellence/department-of-pediatrics">Department of Pediatrics </Link>
                      </li>
                      <li onClick={handleMenuClick}>
                        <Link href="/our-centers-of-excellence/department-of-endocrinology">Department Of Endocrinology </Link>
                      </li>
                    </ul>
                  </li>

                  <li className={`dropdown ${disableHover ? 'disable-hover' : ''} ${pathname.startsWith('/our-facilities') ? 'active' : ''}`}>
                    <Link href="#" className='active-css'>
                      Our Facilities <span className="dropdown-icon"><FaAngleDown /></span>
                    </Link>
                    <ul className="dropdown-menu">
                      <li>
                        <Link href="/our-facilities/emergency-and-trauma-care" onClick={handleMenuClick}>
                          <Image src="/images/nav-icon/emergengy_tu.webp" className="nav-icon-css" width={20} height={20} alt="HDNA Aarogyam Hospital - Trauma Unit Icon" />
                          Emergency & Trauma Care
                        </Link>
                      </li>
                      <li>
                        <Link href="/our-facilities/outpatient-department" onClick={handleMenuClick}>
                          <Image src="/images/nav-icon/opd.webp" className="nav-icon-css" width={20} height={20} alt="HDNA Aarogyam Hospital - OPD Services Icon" />
                          OPD
                        </Link>
                      </li>
                      <li>
                        <Link href="/our-facilities/hemodialysis-treatment" onClick={handleMenuClick}>
                          <Image src="/images/nav-icon/hemodialysis.webp" className="nav-icon-css" width={20} height={20} alt="Hemodialysis Services Icon - HDNA Aarogyam Hospital" />
                          Hermodialysis 24*7
                        </Link>
                      </li>
                      <li>
                        <Link href="/our-facilities/cath-lab" onClick={handleMenuClick}>
                          <Image src="/images/nav-icon/Wards.webp" className="nav-icon-css" width={20} height={20} alt="Patient Wards Icon - HDNA Aarogyam Hospital" />
                          Cathlab
                        </Link>
                      </li>
                      <li>
                        <Link href="/our-facilities/cardiac-icu" onClick={handleMenuClick}>
                          <Image src="/images/nav-icon/cardiac_icu.webp" className="nav-icon-css" width={20} height={20} alt="Cardiac ICU Facility Icon - HDNA Aarogyam Hospital" />
                          Cardiac ICU
                        </Link>
                      </li>
                      <li>
                        <Link href="/our-facilities/medical-and-surgical-icu" onClick={handleMenuClick}>
                          <Image src="/images/nav-icon/MS_icu.webp" className="nav-icon-css" width={20} height={20} alt="Medical-Surgical ICU Icon - HDNA Aarogyam Hospital" />
                          Medical & Surgical ICU
                        </Link>
                      </li>
                      <li>
                        <Link href="/our-facilities/renal-hdu" onClick={handleMenuClick}>
                          <Image src="/images/nav-icon/renal_hdu.webp" className="nav-icon-css" width={20} height={20} alt="Renal HDU Icon - HDNA Aarogyam Hospital" />
                          Renal HDU
                        </Link>
                      </li>
                      <li>
                        <Link href="/our-facilities/private-and-general-wards" onClick={handleMenuClick}>
                          <Image src="/images/nav-icon/Wards.webp" className="nav-icon-css" width={20} height={20} alt="General Ward Services Icon - HDNA Aarogyam Hospital" />
                          Private & General Wards
                        </Link>
                      </li>
                      <li>
                        <Link href="/our-facilities/non-invasive-cardiac-lab" onClick={handleMenuClick}>
                          <Image src="/images/nav-icon/Non-Invansive_Cardiac_Lab.webp" width={20} height={20} className="nav-icon-css" alt="Non-Invasive Cardiac Lab Icon - HDNA Aarogyam Hospital" />
                          Non-Invansive Cardiac Lab (ECHO TMT HOLTER)
                        </Link>
                      </li>
                      <li>
                        <Link href="/our-facilities/radiology" onClick={handleMenuClick}>
                          <Image src="/images/nav-icon/Radiology.webp" className="nav-icon-css" width={20} height={20} alt="Radiology Services Icon - HDNA Aarogyam Hospital" />
                          Radiology
                        </Link>
                      </li>
                      <li>
                        <Link href="/our-facilities/pathology" onClick={handleMenuClick}>
                          <Image src="/images/nav-icon/pathology.webp" className="nav-icon-css" width={20} height={20} alt="Pathology Lab Icon - HDNA Aarogyam Hospital" />
                          Pathology
                        </Link>
                      </li>
                      <li>
                        <Link href="/our-facilities/pharmacy" onClick={handleMenuClick}>
                          <Image src="/images/nav-icon/pharmacy.webp" className="nav-icon-css" width={20} height={20} alt="Pharmacy Services Icon - HDNA Aarogyam Hospital" />
                          Pharmacy
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className={pathname === '/our-tie-ups-and-empanelments' ? 'active' : ''}>
                    <Link href="/our-tie-ups-and-empanelments" className='active-css'>Our Tie-Ups</Link>
                  </li>
                  <li className={pathname === '/our-doctors' ? 'active' : ''}>
                    <Link href="/our-doctors" className='active-css'>Doctors</Link>
                  </li>
                  <li className={pathname === '/gallery' ? 'active' : ''}>
                    <Link href="/gallery" className='active-css'>Gallery</Link>
                  </li>
                  <li className={pathname === '/blog' ? 'active' : ''}>
                    <Link href="/blog" className='active-css'>Blog</Link>
                  </li>
                  <li className={pathname === '/contact' ? 'active' : ''}>
                    <Link href="/contact" className='active-css'>Contact</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-1 text-end'>
              <Link className="navbar-brand" href="/">
                <Image
                  src="/images/nabh-new.webp"
                  alt="NABH Accreditation Badge - HDNA Aarogyam Hospital"
                  width={60}
                  height={42}
                  priority
                />
              </Link>
            </div>
          </div>
        </div>
      </nav>

    </>
  );
}

export default NavMenu
